"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const valueIsControlsStyleComplexUnitPixel = (0, ts_validators_1.buildValueIsShape)('StyleComplexUnitPixel', {
    unit: (0, ts_validators_1.buildValueIsConstant)('px'),
    value: ts_validators_1.valueIsNumber,
});
exports.default = valueIsControlsStyleComplexUnitPixel;
